import { getScheduleChoise, getClassTemplateList, postClassTemplate, updateClassTemplate, deleteClassTemplate } from "@/services/class-template.service";
import { setPaginationDetails, formatDateToHour } from "@/utils/utils";

// initial state
const state = () => ({
  classTemplateModel: {
    excepts: [],
  },

  classTemplateList: [],
});

// mutations
const mutations = {
  setClassTemplateModel(state, data) {
    state.classTemplateModel = data;
  },
  setClassTemplateList(state, data) {
    state.classTemplateList = data;
  },
};

// actions
const actions = {
  async loadClassTemplateList(vuexContext, co) {
    return await getClassTemplateList(co).then((response) => {
      let data = response.data.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;
      items.map((item, index) => {
        item.index = index + 1;
        item.levels = "---";
        item.educationTypes = "---";
        item.classStatuses = "---";
        item.dayAndTime = "---";
        item.price = item.amount + " " + item.currency.isim;
        if (item.classTemplateLevels?.length > 0) {
          item.levels = "";
          item.classTemplateLevels.forEach((classTemplateLevel, index) => {
            if (index != 0) {
              item.levels += ", ";
            }
            item.levels += classTemplateLevel?.levels?.description;
          });
        }
        // if (item.classTemplateEducationTypes.length > 0) {
        //   item.educationTypes = "";
        //   item.classTemplateEducationTypes.forEach((classTemplateEducationType, index) => {
        //     if (index != 0) {
        //       item.educationTypes += ", ";
        //     }
        //     item.educationTypes += classTemplateEducationType?.educationType?.name;
        //   });
        // }
        if (item.classTemplateClassStatuses?.length > 0) {
          item.classStatuses = "";
          item.classTemplateClassStatuses.forEach((classTemplateClassStatus, index) => {
            if (index != 0) {
              item.classStatuses += ", ";
            }
            item.classStatuses += `${classTemplateClassStatus?.classStatus?.startTime} - ${classTemplateClassStatus?.classStatus?.endTime} / ${classTemplateClassStatus?.classStatus?.levels?.description}`;
          });
        }

        if (item.classDayAndTimes?.length > 0) {
          item.dayAndTime = "";
          item.classDayAndTimes.forEach((dayTime, index) => {
            if (index != 0) {
              item.dayAndTime += " / ";
            }
            item.dayAndTime += `${dayTime.day.name} ${formatDateToHour(dayTime.startDate)} -  ${formatDateToHour(dayTime.endDate)}
          `;
          });
        }
      });
      setPaginationDetails(co, totalCount, totalPages);

      vuexContext.commit("setClassTemplateList", items);
      return items;
    });
  },

  async loadScheduleChoise(vuexContext, co) {
    return await getScheduleChoise(co).then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  async postClassTemplate(vuexContext, classTempModel) {
    return await postClassTemplate(classTempModel).then((response) => {
      return response;
    });
  },

  async updateClassTemplate(vuexContext, data) {
    return await updateClassTemplate(data);
  },

  async deleteClassTemplate(vuexContext, data) {
    return await deleteClassTemplate(data);
  },

  addClassTemplateModel(vuexContext, data) {
    vuexContext.commit("setClassTemplateModel", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
